import { createAction, props } from '@ngrx/store';

/**
 * Creación de las acciones de Redux para el usuario actaul
 */
export const ChatActionTypes = {
    CHAT_COMPONENT_INITIALIZED: '[Chat] CHAT_COMPONENT_INITIALIZED',
    CHAT_COMPONENT_DESTROYED: '[Chat] CHAT_COMPONENT_DESTROYED',
    INITIALIZE_CHAT: '[Chat] INITIALIZE_CHAT',
    INITIALIZE_CHAT_SUCCESS: '[Chat] INITIALIZE_CHAT_SUCCESS',
    ENABLE_HUBTYPE: '[Chat] ENABLE_HUBTYPE',
    ENABLE_HUBTYPE_SUCCESS: '[Chat] ENABLE_HUBTYPE_SUCCESS',
    TOGGLE_CHAT: '[Chat] TOGGLE_CHAT',
    TOGGLE_CHAT_SUCCESS: '[Chat] TOGGLE_CHAT_SUCCESS',
    CLOSE_CHAT: '[Chat] CLOSE_CHAT',
    OPEN_CHAT: '[Chat] OPEN_CHAT',
    SET_LIVE_HELP: '[Chat] SET_LIVE_HELP',
    ENABLE_STYLE_ADVISOR: '[Chat] ENABLE_STYLE_ADVISOR',
    ENABLE_STYLE_ADVISOR_SUCCESS: '[Chat] ENABLE_STYLE_ADVISOR_SUCCESS',
    ENABLE_KAKAO: '[Chat] ENABLE_KAKAO',
    ENABLE_MOCHA: '[Chat] ENABLE_MOCHA',
    ENABLE_KAKAO_SUCCESS: '[Chat] ENABLE_KAKAO_SUCCESS',
    ENABLE_URLCHAT: '[Chat] ENABLE_URLCHAT',
    ENABLE_URLCHAT_SUCCESS: '[Chat] ENABLE_URLCHAT_SUCCESS',
    INCREMENT_ENABLED_CHATS: '[Chat] INCREMENT_ENABLED_CHATS',
    RESET_ENABLED_CHATS: '[Chat] RESET_ENABLED_CHATS',
    INIT_HUBTYPE_WIDGET: '[Chat] INIT_HUBTYPE_WIDGET',
    INIT_HUBTYPE_WIDGET_SUCCESS: '[Chat] INIT_HUBTYPE_WIDGET_SUCCESS',
    OPEN_HUBTYPE: '[Chat] OPEN_HUBTYPE',
    OPEN_HUBTYPE_SUCCESS: '[Chat] OPEN_HUBTYPE_SUCCESS',
    SET_ACTIVE_CHAT: '[Chat] SET_ACTIVE_CHAT',
    SET_SCHEDULE_TEXT: '[Chat] SET_SCHEDULE_TEXT',
    CREATE_CHAT_COMPONENT: '[Chat] CREATE_CHAT_COMPONENT',
    CREATE_CHAT_COMPONENT_SUCCESS: '[Chat] CREATE_CHAT_COMPONENT_SUCCESS',
    CREATE_CHAT_COMPONENT_DECLINED: '[Chat] CREATE_CHAT_COMPONENT_DECLINED',
    CREATE_CHAT_COMPONENT_FAILED: '[Chat] CREATE_CHAT_COMPONENT_FAILED',
    DESTROY_CHAT_COMPONENT: '[Chat] DESTROY_CHAT_COMPONENT',
    DESTROY_CHAT_COMPONENT_SUCCESS: '[Chat] DESTROY_CHAT_COMPONENT_SUCCESS',

    SHOW_LARGE_BUTTON: '[Chat] SHOW_LARGE_BUTTON',
    SHOW_SMALL_BUTTON: '[Chat] SHOW_SMALL_BUTTON',
    SHOW_CHAT_BUTTON: '[Chat] SHOW_CHAT_BUTTON',
    HIDE_CHAT_BUTTON: '[Chat] HIDE_CHAT_BUTTON',
};

export const ChatComponentInitilized = createAction(ChatActionTypes.CHAT_COMPONENT_INITIALIZED);
export const ChatComponentDestroyed = createAction(ChatActionTypes.CHAT_COMPONENT_DESTROYED);

export const InitializeChat = createAction(ChatActionTypes.INITIALIZE_CHAT);
export const SetLiveHelp = createAction(ChatActionTypes.SET_LIVE_HELP);
export const InitializeChatSuccess = createAction(ChatActionTypes.INITIALIZE_CHAT_SUCCESS, props<{ visible: boolean }>());
export const EnableUrlChat = createAction(ChatActionTypes.ENABLE_URLCHAT, props<{ payload: any }>());
export const EnableStyleAdvisor = createAction(ChatActionTypes.ENABLE_STYLE_ADVISOR, props<{ payload: any }>());
export const EnableKakao = createAction(ChatActionTypes.ENABLE_KAKAO, props<{ payload: any }>());
export const EnableMocha = createAction(ChatActionTypes.ENABLE_MOCHA, props<{ scheduleMessage?: string }>());
export const ToggleChat = createAction(ChatActionTypes.TOGGLE_CHAT);
export const CloseChat = createAction(ChatActionTypes.CLOSE_CHAT);
export const OpenChat = createAction(ChatActionTypes.OPEN_CHAT);
export const ToggleChatSuccess = createAction(ChatActionTypes.TOGGLE_CHAT_SUCCESS);
export const ShowChatButton = createAction(ChatActionTypes.SHOW_CHAT_BUTTON);
export const HideChatButton = createAction(ChatActionTypes.HIDE_CHAT_BUTTON);
export const IncrementEnabledChats = createAction(ChatActionTypes.INCREMENT_ENABLED_CHATS, props<{ quantity: number }>());
export const ResetEnabledChats = createAction(ChatActionTypes.RESET_ENABLED_CHATS);
export const SetScheduleText = createAction(ChatActionTypes.SET_SCHEDULE_TEXT, props<{ scheduleMessage: string }>());

// #region HUBTYPE CHAT
export const EnableHubtype = createAction(ChatActionTypes.ENABLE_HUBTYPE, props<{ payload: any }>());
export const EnableHubtypeSuccess = createAction(ChatActionTypes.ENABLE_HUBTYPE_SUCCESS);
export const InitHubtypeWidget = createAction(ChatActionTypes.INIT_HUBTYPE_WIDGET, props<{ configuration: any }>());
export const InitHubtypeWidgetSuccess = createAction(ChatActionTypes.INIT_HUBTYPE_WIDGET_SUCCESS);
export const OpenHubtype = createAction(ChatActionTypes.OPEN_HUBTYPE);
export const OpenHubtypeSuccess = createAction(ChatActionTypes.OPEN_HUBTYPE_SUCCESS);
// #endregion

export const SetActiveChat = createAction(
    ChatActionTypes.SET_ACTIVE_CHAT,
    props<{ active: boolean; scheduleMessage: string }>()
);
export const CreateChatComponent = createAction(ChatActionTypes.CREATE_CHAT_COMPONENT);
export const CreateChatComponentSuccess = createAction(ChatActionTypes.CREATE_CHAT_COMPONENT_SUCCESS);
export const CreateChatComponentDeclined = createAction(ChatActionTypes.CREATE_CHAT_COMPONENT_DECLINED);
export const CreateChatComponentFailed = createAction(ChatActionTypes.CREATE_CHAT_COMPONENT_FAILED);
export const DestroyChatComponent = createAction(ChatActionTypes.DESTROY_CHAT_COMPONENT);
export const DestroyChatComponentSuccess = createAction(ChatActionTypes.DESTROY_CHAT_COMPONENT_SUCCESS);

export const ShowLargeButtonChat = createAction(ChatActionTypes.SHOW_LARGE_BUTTON);
export const ShowSmallButtonChat = createAction(ChatActionTypes.SHOW_SMALL_BUTTON);
